import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";

export default function ArrowButton({label, href, newTab}) {
    return (
        <a target={newTab ? "_blank" : ""} referrer={newTab ? "noreferrer" : ""} href={href} className="learn-more new-tab group transition-all duration-300 ease-in-out hover:text-fb">{label}<FontAwesomeIcon icon={faArrowRight} className="text-fb ml-2 group-hover:ml-4 transition-all duration-300 ease-in-out"/></a>
    )
}